import { MemberPermissions } from '@customer-portal/shared/models';

import { MemberAreaPermissions } from './settings-members.model';

export interface MemberPermissionRole {
  area: MemberAreaPermissions;
  type: keyof MemberPermissions;
  roleId: number;
  roleName: string;
}

export const MEMBER_PERMISSION_ROLES: MemberPermissionRole[] = [
  {
    area: MemberAreaPermissions.Contracts,
    type: 'view',
    roleId: 1,
    roleName: 'Contracts_View',
  },
  {
    area: MemberAreaPermissions.Schedules,
    type: 'view',
    roleId: 2,
    roleName: 'Schedule_View',
  },
  {
    area: MemberAreaPermissions.Schedules,
    type: 'edit',
    roleId: 3,
    roleName: 'Schedule_Edit',
  },
  {
    area: MemberAreaPermissions.Audits,
    type: 'view',
    roleId: 8,
    roleName: 'Audits_View',
  },
  {
    area: MemberAreaPermissions.Audits,
    type: 'edit',
    roleId: 9,
    roleName: 'Audits_Edit',
  },
  {
    area: MemberAreaPermissions.Findings,
    type: 'view',
    roleId: 10,
    roleName: 'Findings_View',
  },
  {
    area: MemberAreaPermissions.Findings,
    type: 'edit',
    roleId: 11,
    roleName: 'Findings_Edit',
  },
  {
    area: MemberAreaPermissions.Findings,
    type: 'submit',
    roleId: 12,
    roleName: 'Findings_Submit',
  },
  {
    area: MemberAreaPermissions.Certificates,
    type: 'view',
    roleId: 4,
    roleName: 'Certificates_View',
  },
  {
    area: MemberAreaPermissions.Certificates,
    type: 'edit',
    roleId: 5,
    roleName: 'Certificates_Edit',
  },
  {
    area: MemberAreaPermissions.Financials,
    type: 'edit',
    roleId: 6,
    roleName: 'Financials_Edit',
  },
];
